import React from "react";

const workExperience = [
  {
    name: "SeatGeek",
    description: " UX Designer",
    imgSrc: "/assets/imgs/work-experience/Seatgeek.svg",
    to: "/home",
    duration: "Nov 2023 – Present | New York, NY",
  },
  {
    name: "Clearwater Analytics",
    description: "UX Designer",
    imgSrc: "/assets/imgs/work-experience/ClearwaterAnalytics.png",
    to: "/home",
    duration: "Feb 2021 – Apr 2023 | Noida, India",
  },
  // {
  //   name: "Accenture",
  //   description: "UI/UX Designer",
  //   imgSrc: "/assets/imgs/work-experience/accenture.png",
  //   to: "/home",
  //   duration: "Jan 2019 – Feb 2022 | India",
  // },
  // {
  //   name: "Smartbit Digital",
  //   description: "UI Designer",
  //   imgSrc: "/assets/imgs/work-experience/smartbit-digital.png",
  //   to: "/home",
  //   duration: "Jan 2018 – Dec 2018 | India",
  // },
];

const Portfolio = () => {
  return (
    <section className="container pt-140">
      <h6 className="sub-title main-color pt-40">Work Experience</h6>
      <div className="portfolio-card-container pt-80">
        {workExperience.map((work, index) => (
          <div className="portfolio-card" key={index}>
            <img
              className="portfolio-card-image"
              src={work.imgSrc}
              alt={work.name}
            />
            <div className="mt-20 portfolio-card-name">{work.name}</div>
            <div className="portfolio-card-content">
              <div className="portfolio-card-description mt-25">
                {work.description}
              </div>
              <div className="portfolio-card-duration mt-25">
                {work.duration}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
